import {ErrorStateScheduleEnum} from '../error-state-schedule.enum';

export enum PanelEntitlementReportsErrorStatesEnum {
    GetReportFailed = ErrorStateScheduleEnum.EntitlementReportResolverStatesStartIndex,
    GetPeriodsFailed
}
